var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.alive)?_c('keep-alive',[_c('router-view')],1):_c('router-view'),_c('BackTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }